var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticStyle:{"text-align":"center","margin-top":"200px"}},[_c('p',{staticStyle:{"font-size":"32px","font-weight":"bold","color":"#6f7180"}},[_vm._v(_vm._s(_vm.nowDateTime))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"48px"}},[_vm._v("欢迎您使用表白墙信息后台管理平台")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c03a50e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/welcome.vue
// module id = null
// module chunks = 